import { get } from './http';
import store from '../store';
import { logX } from '../common/libs/utils';
import { initUserVariables } from './userVariables';

export const getUser = async () => {
	if(store.state.readonly) {
		return;
	}
	
	let token = window.localStorage.getItem(`anybot_user_token`);
	let user = await get('/me', { token: token || 'new', access_key: store.state.bot.key });

	store.state.user = {
		...user,
		token: user?.oid || token,
		access_key: store.state.bot.key
	};
	if(user?.id) {
		localStorage.setItem(`anyhook_uid_${store.state.bid}`, user.id);
	}
	initUserVariables();
	logX('USER INFO', 'purple', store.state.user);
	user?.oid && window.localStorage.setItem('anybot_user_token', user.oid);
	return user;
};
